import { Injectable } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { GameType } from '../models/game.model';
@Injectable({
  providedIn: 'root',
})
export class TotalGameService {
  private readonly maxAmount: number = 29999.0;

  // Son tomados de gameInfo
  // A confirmar si son los correctos
  private readonly maxPrices: { [key: string]: number } = {
    Pronosports: 2000000,
    Chispazo: 1260000,
    Ganagato: 2000,
    Melate: 3780000,
    MR: 1260000,
    Progol: 486000,
    ProgolMS: 108000,
    Protouch: 324000,
    Tris: 10000,
  };

  constructor(
    private alertController: AlertController,
    private navCtrl: NavController,
    private translateS: TranslateService
  ) {}

  verifyAmount(amount: number): boolean {
    if (amount > this.maxAmount) {
      //   this.showAlert('Error', 'Tu monto excede el límite permitido por Lotería Nacional.');
      this.showAlert('Error', 'La apuesta es mayor al limite permitido por Loteria Nacional.');
      return false;
    }
    return true;
  }

  isValidBet(gameType: string, amount: number): boolean {
    const maxPrice = this.maxPrices[gameType];
    return maxPrice !== undefined ? amount < maxPrice : false;
  }
  async showAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['Aceptar'],
    });
    await alert.present();
  }

  validateMessageIgt(message?: any, errorRetries?: false, gameType?: GameType) {
    if (message) {
      const response = this.formatResultText(message);

      const isErrorGame = response['resultText'] === 'errorInvalidBoardData';
      const errorCategory = isErrorGame ? gameType : 'execute-response';

      let errorKey: string;
      if (response['serverErrorText']) {
        errorKey = 'serverErrorText';
      } else if (response['resultText']) {
        errorKey = response['resultText'];
      } else {
        errorKey = 'emptyError';
      }

      const result = this.translateS.instant(`error.${errorCategory}.${errorKey}`);

      // console.log('MESSAGE FROM IGT: ', response['serverErrorText'] || response['resultText'] || 'No message');
      // console.log('RESPONSE: ', response['drawNumber']);
      // console.log('gameType: ', gameType);

      if (response['serverErrorText'] || response['resultText'] !== 'ok') {
        this.showAlert('Error', result);
      }
    } else if (errorRetries) {
      this.showAlert('Error', this.translateS.instant('El limite de apuesta supera el limite permitido'));
    }
  }
  formatResultText(text: any): { [name: string]: string } {
    // Validar la estructura de la respuesta
    if (!text || !text.executeReturn || !text.executeReturn.executeReturn) {
      console.error('Invalid input structure:', text);
      return {
        serverErrorText: '',
        resultText: '',
      };
    }

    // Normalizar `executeReturn` a un array si es un objeto
    const executeReturnArray = Array.isArray(text.executeReturn.executeReturn)
      ? text.executeReturn.executeReturn
      : [text.executeReturn.executeReturn];

    // Mapear y reducir el array de NameValuePair
    const result = executeReturnArray
      .map((g: any) => {
        const name = g.name?.$value || '';
        const value = g.value?.$value || '';
        return { name, value };
      })
      .reduce((acc: any, item: { name: string; value: string }) => {
        acc[item.name] = item.value;
        return acc;
      }, {} as { [key: string]: string });

    // Asegurarse de que serverErrorText y resultText estén presentes
    return {
      serverErrorText: result['serverErrorText'] || '',
      resultText: result['resultText'] || '',
      ...result, // Incluir el resto de los campos
    };
  }

  formatResponseText(response: any) {
    const key = Object.keys(response)[0];
    if (key && response[key]?.responseHeadTerminal?.respCodeDescription) {
      const textError = response[key]?.responseHeadTerminal?.respCodeDescription;
      this.showAlert('Error', textError);
      //return response[key].responseHeadTerminal.respCodeDescription;
    }
    return 'Descripción no disponible';
  }
}
